import ReactGA from "react-ga4";

const MEASUREMENT_ID = "G-3153MKKSGT"; // Your GA4 ID

export const initGA = () => {
  ReactGA.initialize(MEASUREMENT_ID);
};

export const trackPageView = (path) => {
  ReactGA.send({ hitType: "pageview", page: path });
};
